import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { action } from '@ember/object';
import Component from '@glimmer/component';

// Subset of DChartComparePoint — only the fields the template actually reads.
export interface CompareDisplayData {
	changeStr: string;
	indicatorClass: string;
	compareText?: string;
	valueStr?: string;
	onClick?: (event: PointerEvent) => void;
}

interface Args {
	model: CompareDisplayData[];
	showCompareText?: boolean;
	showCompareValue?: boolean;
	showTextInTooltip?: boolean;
}

export default class BlockContentCommonComparesComponent extends Component<Args> {
	get showCompareWrapper(): boolean {
		return !!this.args.showCompareText || !!this.args.showCompareValue;
	}

	@action
	onClick(item: CompareDisplayData, event: PointerEvent): void {
		if (item.onClick) {
			item.onClick(event);
		}
	}

	<template>
		{{#if @model}}
			<div class="bc__compares">
				{{#each @model as |comparePoint|}}
					{{#if comparePoint.changeStr}}
						<div class="bc__compare bc__compare--{{comparePoint.indicatorClass}}">
							<span
								class="bc__compare__change"
								title={{if @showTextInTooltip comparePoint.compareText}}
							>
								{{comparePoint.changeStr}}
							</span>
							{{#if this.showCompareWrapper}}
								{{#if comparePoint.compareText}}
									<small class="bc__compare__text">
										{{#if @showCompareText}}
											{{comparePoint.compareText}}
										{{/if}}
										{{#if @showCompareValue}}
											<span
												role="button"
												class={{if
													comparePoint.onClick
													"bc__compare__value--clickable"
												}}
												{{on "click" (fn this.onClick comparePoint)}}
											>
												{{#if comparePoint.valueStr}}
													({{comparePoint.valueStr}})
												{{/if}}
											</span>
										{{/if}}
									</small>
								{{/if}}
							{{/if}}
						</div>
					{{/if}}
				{{/each}}
			</div>
		{{/if}}
	</template>
}
